import React from "react";

function fmtPct(x) {
  const n = Number(x);
  if (!Number.isFinite(n)) return "—";
  const sign = n > 0 ? "+" : "";
  return `${sign}${n.toFixed(2)}%`;
}

function fmtNum(x) {
  const n = Number(x);
  if (!Number.isFinite(n)) return "—";
  return n.toLocaleString("pt-BR", { maximumFractionDigits: 4 });
}

export default function MarketTape({ items, loading = false, error = null }) {
  return (
    <div className="market-tape">
      <div className="market-tape-header">
        <div className="market-tape-title">Mercado agora</div>
        {error ? <div className="market-tape-error">indisponível</div> : null}
      </div>

      <div className="market-tape-row">
        {loading ? (
          Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="market-tile market-tile-skel" />
          ))
        ) : (items?.length ? (
          items.map((it) => {
            const chg = Number(it.changePct);
            const cls =
              !Number.isFinite(chg) ? "" : chg > 0 ? "up" : chg < 0 ? "down" : "";

            return (
              <div key={it.key || it.symbol} className={`market-tile ${cls}`}>
                <div className="market-tile-top">
                  <div className="market-sym">{it.label || it.symbol}</div>
                  <div className="market-pct">{fmtPct(it.changePct)}</div>
                </div>
                <div className="market-price">{fmtNum(it.price)}</div>
                <div className="market-sub">
                  {it.subLabel || it.currency || ""}
                </div>
              </div>
            );
          })
        ) : (
          <div className="market-tape-empty">Sem dados no momento.</div>
        ))}
      </div>
    </div>
  );
}
